import { AnyMxRecord } from "dns";
import { MANAGEMENT_ACTIONS } from "./actions";

export interface ILoginState {
  isPending: boolean;
  isError: boolean;
  errorMessage: string;
  manageData: any;
}

const initialState: ILoginState = {
  isPending: false,
  isError: false,
  errorMessage: "",
  manageData: {},
};

export const managementReducer = (state: ILoginState = initialState, action): ILoginState => {
  switch (action.type) {
    case MANAGEMENT_ACTIONS.FETCH_PENDING: {
      return {
        ...state,
        isPending: true,
      };
    }
    case MANAGEMENT_ACTIONS.FETCH_FAILED: {
      return {
        ...state,
        isPending: false,
        isError: true,
        errorMessage: action.payload,
      };
    }
    case MANAGEMENT_ACTIONS.FETCH_SUCCESS: {
      return {
        ...state,
        isPending: false,
        isError: false,
        manageData: action.payload,
      };
    }
    default:
      return state;
  }
};
